export class NotificationTimer {
  private timerId: number | null = null;
  private readonly callback: () => void;
  private readonly delay: number;
  private readonly actionType: any;

  constructor(callback: () => void, delay: number, type: any) {
    this.callback = callback;
    this.delay = delay;
    this.actionType = type;
    this.start();
  }

  start(): void {
    this.timerId = window.setTimeout(this.callback, this.delay);
  }

  stop(): void {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  action(): void {
    this.callback();
  }

  type(): any {
    return this.actionType;
  }
}

type ShowNotificationParams = {
  data?: any;
  emoji?: string;
  title?: string;
  link?: string;
  link_title?: string;
  ok_title?: string;
  undo_title?: string;
  ok_action?: () => void;
  undo_action?: () => void;
};

export function showNotification(type: string, params?: ShowNotificationParams): void {
  const event = new CustomEvent('showNotification', {
    detail: {
      type: type,
      params: { ...params },
    },
  });

  window.dispatchEvent(event);
}

export function closeCurrentNotification() {
  const event = new CustomEvent('closeCurrentNotification');
  window.dispatchEvent(event);
}

export function plan_changed() {
  showNotification('any_type', {
    emoji: '👌',
    title: 'Changes have been applied',
    ok_action: undefined,
  });
}
